import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useDeleteAdminImportRequest() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (importRequestId: number) => {
      const response = await fetch(`/admin/api/import_requests/${importRequestId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const message =
          response.status === 403
            ? '権限がありません'
            : ((body as { error?: string }).error ?? 'リクエストの削除に失敗しました');
        throw new Error(message);
      }
      return response.json();
    },
    onSuccess: (_data, importRequestId) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'import_requests', importRequestId] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'import_requests'] });
    },
  });
}
